import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { eur } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

export default function OffertaCura({ testid = "offer-card", showDiscoverLink = false, minimal = false }) {
  const [offer, setOffer] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    api.get("/offer").then((r) => setOffer(r.data)).catch(() => {});
  }, []);

  if (!offer) return null;

  const cta = user ? `/checkout?type=abbonamento&plan=${offer.id}` : "/accedi";

  return (
    <div className="rounded-3xl border-2 border-[#4a7c59] bg-[#e8f0eb] overflow-hidden grid md:grid-cols-2" data-testid={testid}>
      <img
        src="/offerta-3-mesi.jpg"
        alt="Offerta 3 mesi di cura — Sempre Accanto"
        className="w-full h-60 sm:h-72 md:h-full object-cover object-top"
        data-testid={`${testid}-image`}
      />
      <div className="p-8 flex flex-col justify-center">
        {!minimal && (
          <>
            <p className="eyebrow mb-1">Sempre Accanto</p>
            <p className="font-serif italic text-lg text-navy mb-5">La cura nel tempo.</p>
            <span className="inline-block self-start text-xs font-bold tracking-widest uppercase text-white bg-[#2f5d3e] rounded-full px-4 py-1.5 mb-4">
              {offer.badge}
            </span>
          </>
        )}
        <h2 className="font-serif text-3xl sm:text-4xl text-navy mb-5">3 mesi di cura</h2>
        <div className="grid grid-cols-3 divide-x divide-[#d1e2d5] text-center mb-5" data-testid={`${testid}-stats`}>
          <div className="px-2">
            <p className="font-serif text-2xl text-navy">{offer.interventions_total}</p>
            <p className="text-xs text-muted-soft">interventi complessivi</p>
          </div>
          <div className="px-2">
            <p className="font-serif text-2xl text-navy">{offer.frequency}</p>
            <p className="text-xs text-muted-soft">interventi al mese</p>
          </div>
          <div className="px-2">
            <p className="font-serif text-2xl text-navy">{offer.duration_months}</p>
            <p className="text-xs text-muted-soft">mesi di servizio</p>
          </div>
        </div>
        <p className="font-serif text-5xl text-navy mb-5" data-testid={`${testid}-price`}>{eur(offer.price)}</p>
        <Link to={cta} data-testid={`${testid}-cta`} className="btn-sage w-full">
          {minimal ? "Scegli i 3 mesi di cura" : "Scegli questo abbonamento"}
        </Link>
        {showDiscoverLink && (
          <Link to="/abbonamenti" data-testid={`${testid}-discover`} className="text-sm font-semibold text-[#1e3a5f] hover:underline text-center mt-3">
            Scopri tutti gli abbonamenti
          </Link>
        )}
        {!minimal && (
          <div className="flex justify-between gap-3 flex-wrap mt-6 text-xs text-muted-soft">
            <span>Fiori freschi ad ogni intervento</span>
            <span>Servizio professionale e affidabile</span>
            <span>La tranquillità di una cura continua</span>
          </div>
        )}
      </div>
    </div>
  );
}
